import axios from 'axios';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addAlert } from '../../store/slices/alertReducer'
import * as formsApi from "../../api/forms";


export const getDefinition = createAsyncThunk(
  "form/getDefinition", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      const formId = params;
      return await formsApi.getDefinition(formId, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const formSlice = createSlice({
  name: 'form',
  initialState: {
    formDefinition: {},
    loading: '',
  },
  reducers: {
    clearForm: (state, action) => {
        state.formDefinition = {};
        state.loading = "loaded";
        state.currentRequestId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getDefinition.pending, (state, action) => {
        state.formDefinition = {};
        state.loading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      getDefinition.fulfilled, (state, { payload  }) => {
        state.formDefinition = payload;
        state.loading = "loaded";
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getDefinition.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.loading = "error";
        }
        state.formDefinition = {};
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
  }
})

export const { clearForm } = formSlice.actions
export default formSlice.reducer
